import { IApplicationState } from '../../../../../../types/types';
import { getAuthUser } from '../../../../../../store/model/authUser/selectors/getAuthUser';
import { isUserAuthorized } from '../../../../../../store/model/authUser/selectors/isUserAuthorized';

export const authUserEmailSelector = (state: IApplicationState): string => {
    if (!isUserAuthorized(state)) return null;
    return getAuthUser(state).email;
};
